export class BillingModel {
    id: string = "";
    description: string = "";
    amount: number = 0;

    constructor(b?:Partial<BillingModel>) {
        Object.assign(this, b)
    }
}
